module.exports = __webpack_public_path__ + "static/media/whatsapp-ivr.f97eb6f8.png";